/* ============================================================
   HFO - SIBLING SWATCHES V4
   COLLECTION + SEARCH + GENERAL PRODUCT GRIDS

   PERFORMANCE:
   - Lightweight /search?view=hfo-siblings resolver
   - No full collection Section Rendering requests
   - Metaobject pages 2+ requested in parallel
   - Candidate is displayed as soon as its page returns
   - Newer/higher Metaobject ID replaces older result
   - 6 hour localStorage cache
   - Shared winner cache with product page/recommendations

   DUPLICATE RULE:
   Highest Metaobject entry ID wins.
   ============================================================ */


/* ============================================================
   FORCE NORMAL COLLECTION PAGINATION
   ============================================================ */

(function () {
  'use strict';

  if (window.HFOCollectionPaginationFixInstalled) {
    return;
  }

  window.HFOCollectionPaginationFixInstalled = true;


  function isPaginationLink(link) {
    if (!link || !link.href) {
      return false;
    }

    var paginationContainer = link.closest(
      '.pagination,' +
      '.pagination-custom,' +
      '.pagination__list,' +
      '.collection__pagination,' +
      '[data-pagination],' +
      'nav[aria-label*="pagination" i]'
    );

    if (!paginationContainer) {
      return false;
    }

    var url;

    try {
      url = new URL(
        link.href,
        window.location.origin
      );
    } catch (error) {
      return false;
    }

    if (
      url.origin !==
      window.location.origin
    ) {
      return false;
    }

    if (
      !url.searchParams.has('page')
    ) {
      return false;
    }

    return true;
  }


  document.addEventListener(
    'click',

    function (event) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var target = event.target;

      if (
        !target ||
        !target.closest
      ) {
        return;
      }

      var link =
        target.closest('a[href]');

      if (
        !isPaginationLink(link)
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {
        event.stopImmediatePropagation();
      }

      window.location.assign(
        link.href
      );
    },

    true
  );
})();



/* ============================================================
   GRID SIBLING RESOLVER
   ============================================================ */

(function () {
  'use strict';


  /*
   * Product page recommendations have their own optimized loader.
   */
  if (
    /\/products\/[^/]+\/?$/i.test(
      window.location.pathname
    )
  ) {
    return;
  }


  if (
    window.HFOGridSiblingResolverV4Installed
  ) {
    return;
  }

  window.HFOGridSiblingResolverV4Installed = true;



  /* ==========================================================
     SETTINGS
     ========================================================== */

  var CACHE_TTL =
    6 * 60 * 60 * 1000;


  var CARD_CACHE_PREFIX =
    'hfoSiblingCardV4:';


  var WINNER_CACHE_PREFIX =
    'hfoSiblingWinnerV2:';


  var VERIFIED_ATTRIBUTE =
    'data-hfo-sibling-v4-verified';


  var currentScript =
    document.currentScript;


  var siblingSwatchesSrc =
    '';


  if (currentScript) {
    siblingSwatchesSrc =
      currentScript.getAttribute(
        'data-sibling-swatches-src'
      ) || '';
  }


  var shopRoot = '/';

  if (
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
  ) {
    shopRoot =
      Shopify.routes.root;
  }


  var resolverUrl =
    shopRoot + 'search';


  var scanRunning = false;
  var scanAgain = false;
  var scanTimer = null;



  /* ==========================================================
     BASIC HELPERS
     ========================================================== */

  function cssEscape(value) {
    value = String(value);

    if (
      window.CSS &&
      typeof window.CSS.escape === 'function'
    ) {
      return window.CSS.escape(value);
    }

    return value.replace(
      /[^a-zA-Z0-9_-]/g,
      '\\$&'
    );
  }


  function normalizeEntryId(value) {
    value =
      String(value || '0')
        .replace(/\D/g, '')
        .replace(/^0+/, '');

    return value || '0';
  }


  function compareEntryIds(a, b) {
    a = normalizeEntryId(a);
    b = normalizeEntryId(b);

    if (a.length > b.length) {
      return 1;
    }

    if (a.length < b.length) {
      return -1;
    }

    if (a === b) {
      return 0;
    }

    return a > b ? 1 : -1;
  }


  function now() {
    return Date.now();
  }



  /* ==========================================================
     LOCAL STORAGE
     ========================================================== */

  function readLocal(key) {
    try {
      var raw =
        localStorage.getItem(key);

      if (!raw) {
        return null;
      }

      var data =
        JSON.parse(raw);

      if (
        !data ||
        !data.savedAt ||
        (
          now() - data.savedAt >
          CACHE_TTL
        )
      ) {
        localStorage.removeItem(key);
        return null;
      }

      return data;

    } catch (error) {
      return null;
    }
  }


  function writeLocal(
    key,
    value
  ) {
    try {
      value.savedAt = now();

      localStorage.setItem(
        key,
        JSON.stringify(value)
      );
    } catch (error) {
      /*
       * Ignore storage quota/privacy errors.
       */
    }
  }


  function getCardCache(productId) {
    return readLocal(
      CARD_CACHE_PREFIX +
      String(productId)
    );
  }


  function setCardCache(
    productId,
    result
  ) {
    if (!result) {
      return;
    }

    writeLocal(
      CARD_CACHE_PREFIX +
      String(productId),
      {
        entryId:
          normalizeEntryId(
            result.getAttribute(
              'data-sibling-entry-id'
            ) || '0'
          ),

        html:
          result.outerHTML
      }
    );
  }


  function setWinnerMeta(
    productId,
    candidate
  ) {
    if (!candidate) {
      return;
    }

    writeLocal(
      WINNER_CACHE_PREFIX +
      String(productId),
      {
        entryId:
          normalizeEntryId(
            candidate.entryId
          ),

        page:
          Number(
            candidate.page || 1
          ),

        count:
          Number(
            candidate.count || 0
          ),

        handle:
          String(
            candidate.handle || ''
          )
      }
    );
  }



  /* ==========================================================
     LOAD PALO ALTO SIBLING SCRIPT
     ========================================================== */

  function ensureSiblingScript() {
    if (
      window.customElements &&
      customElements.get(
        'sibling-swatches'
      )
    ) {
      return;
    }

    if (
      document.querySelector(
        'script[data-hfo-sibling-swatches-script]'
      )
    ) {
      return;
    }

    if (!siblingSwatchesSrc) {
      return;
    }

    var script =
      document.createElement('script');

    script.src =
      siblingSwatchesSrc;

    script.defer = true;

    script.setAttribute(
      'data-hfo-sibling-swatches-script',
      ''
    );

    document.head.appendChild(
      script
    );
  }



  /* ==========================================================
     PRODUCT CARD HELPERS
     ========================================================== */

  function getHosts(productId) {
    return document.querySelectorAll(
      '[data-hfo-grid-sibling-host]' +
      '[data-product-id="' +
      cssEscape(
        String(productId)
      ) +
      '"]'
    );
  }


  function getCurrentResult(host) {
    if (!host) {
      return null;
    }

    return (
      host.querySelector(
        ':scope > [data-hfo-grid-sibling-result]'
      ) ||
      host.querySelector(
        '[data-hfo-grid-sibling-result]'
      )
    );
  }


  function getResultEntryId(result) {
    if (!result) {
      return '0';
    }

    return normalizeEntryId(
      result.getAttribute(
        'data-sibling-entry-id'
      ) || '0'
    );
  }


  function removeRegularVariantSwatches(
    host
  ) {
    if (!host) {
      return;
    }

    var card =
      host.closest(
        '[data-product-block]'
      );

    if (!card) {
      return;
    }

    var fields =
      card.querySelectorAll(
        '[data-grid-swatch-fieldset]'
      );

    for (
      var i = 0;
      i < fields.length;
      i++
    ) {
      if (
        !host.contains(fields[i])
      ) {
        fields[i].remove();
      }
    }
  }



  /* ==========================================================
     PREPARE RESOLVER RESULT FOR CURRENT PRODUCT
     ========================================================== */

  function prepareResult(
    source,
    productId
  ) {
    if (!source) {
      return null;
    }

    productId =
      String(productId);

    var result =
      source.cloneNode(true);

    result.setAttribute(
      'data-product-id',
      productId
    );


    var links =
      result.querySelectorAll(
        '[data-sibling-product-id]'
      );

    var currentLink = null;


    for (
      var i = 0;
      i < links.length;
      i++
    ) {
      var link = links[i];

      link.removeAttribute(
        'aria-current'
      );

      var checks =
        link.querySelectorAll(
          '.icon-check'
        );

      for (
        var c = 0;
        c < checks.length;
        c++
      ) {
        if (checks[c].parentNode) {
          checks[c].parentNode.removeChild(
            checks[c]
          );
        }
      }

      var siblingId =
        String(
          link.getAttribute(
            'data-sibling-product-id'
          ) || ''
        );

      if (
        siblingId === productId
      ) {
        currentLink = link;
      }
    }


    if (currentLink) {
      currentLink.setAttribute(
        'aria-current',
        'true'
      );


      var component =
        result.querySelector(
          'sibling-swatches'
        );

      if (component) {
        var productUrl =
          currentLink.getAttribute(
            'href'
          ) || '';

        var productImage =
          currentLink.getAttribute(
            'data-sibling-featured-image-url'
          ) || '';

        if (productUrl) {
          component.setAttribute(
            'data-product-url',
            productUrl
          );
        }

        if (productImage) {
          component.setAttribute(
            'data-product-image',
            productImage
          );
        }
      }


      var usesImage =
        currentLink.classList.contains(
          'siblings__swatch--image'
        );

      var soldOut =
        currentLink.classList.contains(
          'siblings__swatch--sold-out'
        );


      if (
        !usesImage &&
        !soldOut
      ) {
        var tooltip =
          currentLink.querySelector(
            'tooltip-component'
          );

        if (
          tooltip &&
          !tooltip.querySelector(
            '.icon-check'
          )
        ) {
          var check =
            document.createElement(
              'span'
            );

          check.className =
            'icon icon-check';

          tooltip.insertBefore(
            check,
            tooltip.firstChild
          );
        }
      }
    }


    return result;
  }



  /* ==========================================================
     INSERT NEWER RESULT
     ========================================================== */

  function insertResult(
    productId,
    source
  ) {
    var hosts =
      getHosts(productId);

    if (
      !hosts.length ||
      !source
    ) {
      return false;
    }


    var candidateId =
      getResultEntryId(source);

    var inserted = false;


    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      var host = hosts[i];

      var current =
        getCurrentResult(host);

      var currentId =
        current
          ? getResultEntryId(current)
          : normalizeEntryId(
              host.getAttribute(
                'data-hfo-selected-sibling-entry-id'
              ) || '0'
            );


      if (
        current &&
        currentId !== '0' &&
        compareEntryIds(
          candidateId,
          currentId
        ) <= 0
      ) {
        continue;
      }


      var prepared =
        prepareResult(
          source,
          productId
        );

      if (!prepared) {
        continue;
      }


      removeRegularVariantSwatches(
        host
      );


      if (
        current &&
        current.parentNode === host
      ) {
        host.replaceChild(
          prepared,
          current
        );
      } else {
        var placeholder =
          host.querySelector(
            ':scope > [data-hfo-grid-sibling-placeholder]'
          ) ||
          host.querySelector(
            '[data-hfo-grid-sibling-placeholder]'
          );

        if (placeholder) {
          host.insertBefore(
            prepared,
            placeholder
          );
        } else {
          host.appendChild(
            prepared
          );
        }
      }


      host.setAttribute(
        'data-hfo-selected-sibling-entry-id',
        candidateId
      );


      inserted = true;
    }


    if (inserted) {
      ensureSiblingScript();

      document.dispatchEvent(
        new CustomEvent(
          'hfo:grid-siblings:loaded',
          {
            detail: {
              productId:
                String(productId),

              entryId:
                candidateId
            }
          }
        )
      );
    }


    return inserted;
  }



  /* ==========================================================
     RESTORE CACHE IMMEDIATELY
     ========================================================== */

  function restoreCachedProduct(
    productId
  ) {
    var cached =
      getCardCache(productId);

    if (
      !cached ||
      !cached.html
    ) {
      return false;
    }

    var doc =
      new DOMParser()
        .parseFromString(
          cached.html,
          'text/html'
        );

    var result =
      doc.querySelector(
        '[data-hfo-grid-sibling-result]'
      );

    if (!result) {
      return false;
    }

    return insertResult(
      productId,
      result
    );
  }


  function restoreAllLiveCaches() {
    var hosts =
      document.querySelectorAll(
        '[data-hfo-grid-sibling-host]' +
        '[data-product-id]'
      );

    var restored =
      Object.create(null);

    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      var productId =
        String(
          hosts[i].getAttribute(
            'data-product-id'
          ) || ''
        );

      if (
        !productId ||
        restored[productId]
      ) {
        continue;
      }

      restored[productId] = true;

      restoreCachedProduct(
        productId
      );
    }
  }



  /* ==========================================================
     COLLECT PRODUCTS THAT STILL NEED VERIFICATION
     ========================================================== */

  function collectProducts() {
    var hosts =
      document.querySelectorAll(
        '[data-hfo-grid-sibling-host]' +
        '[data-product-id]'
      );

    var ids = [];
    var map =
      Object.create(null);


    for (
      var i = 0;
      i < hosts.length;
      i++
    ) {
      var host =
        hosts[i];

      var productId =
        String(
          host.getAttribute(
            'data-product-id'
          ) || ''
        );

      if (!productId) {
        continue;
      }

      if (
        host.getAttribute(
          VERIFIED_ATTRIBUTE
        ) === 'true'
      ) {
        continue;
      }

      if (!map[productId]) {
        map[productId] = true;

        ids.push(productId);
      }
    }


    return {
      ids: ids,
      map: map
    };
  }



  /* ==========================================================
     CANDIDATE SELECTION
     ========================================================== */

  function chooseCandidate(
    bestCandidates,
    productId,
    candidate
  ) {
    var current =
      bestCandidates[
        productId
      ];

    if (!current) {
      bestCandidates[
        productId
      ] =
        candidate;

      return true;
    }


    var compare =
      compareEntryIds(
        candidate.entryId,
        current.entryId
      );


    if (
      compare > 0 ||
      (
        compare === 0 &&
        candidate.count >
          current.count
      )
    ) {
      bestCandidates[
        productId
      ] =
        candidate;

      return true;
    }


    return false;
  }



  /* ==========================================================
     PROCESS ONE RESOLVER PAGE

     IMPORTANT:
     Improved candidate is displayed IMMEDIATELY.
     We do not wait for every page.
     ========================================================== */

  function processResolverPage(
    html,
    requestedMap,
    bestCandidates,
    fallbackPage
  ) {
    if (!html) {
      return {
        valid: false,
        totalPages: 1,
        currentPage: fallbackPage || 1,
        pageParam: ''
      };
    }


    var doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    var resolver =
      doc.querySelector(
        '[data-hfo-sibling-resolver]'
      );


    if (!resolver) {
      return {
        valid: false,
        totalPages: 1,
        currentPage: fallbackPage || 1,
        pageParam: ''
      };
    }


    var pageInfo =
      doc.querySelector(
        '[data-hfo-resolver-page]'
      );


    var totalPages = 1;
    var currentPage =
      fallbackPage || 1;
    var pageParam = '';


    if (pageInfo) {
      totalPages =
        parseInt(
          pageInfo.getAttribute(
            'data-hfo-resolver-total-pages'
          ) || '1',
          10
        );

      currentPage =
        parseInt(
          pageInfo.getAttribute(
            'data-hfo-resolver-page'
          ) ||
          String(currentPage),
          10
        );

      pageParam =
        String(
          pageInfo.getAttribute(
            'data-hfo-resolver-page-param'
          ) || ''
        );
    }


    var templates =
      doc.querySelectorAll(
        'template[data-hfo-sibling-group]'
      );


    for (
      var i = 0;
      i < templates.length;
      i++
    ) {
      var template =
        templates[i];

      var idsString =
        String(
          template.getAttribute(
            'data-product-ids'
          ) || ''
        );

      if (
        !idsString ||
        !template.content
      ) {
        continue;
      }


      var groupIds =
        idsString.split(',');


      var source =
        template.content.querySelector(
          '[data-hfo-grid-sibling-result]'
        );


      if (!source) {
        continue;
      }


      var entryId =
        normalizeEntryId(
          template.getAttribute(
            'data-sibling-entry-id'
          ) ||
          source.getAttribute(
            'data-sibling-entry-id'
          ) ||
          '0'
        );


      var count =
        parseInt(
          template.getAttribute(
            'data-sibling-count'
          ) ||
          source.getAttribute(
            'data-sibling-count'
          ) ||
          String(groupIds.length),
          10
        ) || 0;


      var handle =
        String(
          template.getAttribute(
            'data-sibling-entry-handle'
          ) ||
          source.getAttribute(
            'data-sibling-entry-handle'
          ) ||
          ''
        );


      for (
        var x = 0;
        x < groupIds.length;
        x++
      ) {
        var productId =
          String(
            groupIds[x] || ''
          ).trim();


        if (
          !productId ||
          !requestedMap[productId]
        ) {
          continue;
        }


        var candidate = {
          entryId: entryId,
          count: count,
          handle: handle,
          page: currentPage,
          source:
            source.cloneNode(true)
        };


        if (
          chooseCandidate(
            bestCandidates,
            productId,
            candidate
          )
        ) {
          /*
           * Display this candidate now.
           * If a newer page returns later it will replace it.
           */
          insertResult(
            productId,
            candidate.source
          );


          var hosts =
            getHosts(productId);

          if (hosts.length) {
            var current =
              getCurrentResult(
                hosts[0]
              );

            if (current) {
              setCardCache(
                productId,
                current
              );
            }
          }


          setWinnerMeta(
            productId,
            candidate
          );
        }
      }
    }


    return {
      valid: true,
      totalPages: totalPages,
      currentPage: currentPage,
      pageParam: pageParam
    };
  }



  /* ==========================================================
     FETCH RESOLVER PAGE
     ========================================================== */

  function fetchResolverPage(
    pageNumber,
    productIds,
    requestedMap,
    pageParam,
    bestCandidates
  ) {
    var url =
      new URL(
        resolverUrl,
        window.location.origin
      );


    url.searchParams.set(
      'view',
      'hfo-siblings'
    );

    url.searchParams.set(
      'q',
      productIds.join(',')
    );


    if (
      pageNumber > 1 &&
      pageParam
    ) {
      url.searchParams.set(
        pageParam,
        String(pageNumber)
      );
    }


    url.searchParams.set(
      '_hfo',
      'grid-v4-fast'
    );


    return fetch(
      url.toString(),
      {
        method: 'GET',
        credentials: 'same-origin',

        headers: {
          'X-Requested-With':
            'XMLHttpRequest'
        }
      }
    )

      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'HFO sibling resolver HTTP ' +
              response.status
            );
          }

          return response.text();
        }
      )

      .then(
        function (html) {
          return processResolverPage(
            html,
            requestedMap,
            bestCandidates,
            pageNumber
          );
        }
      );
  }



  /* ==========================================================
     FINALIZE
     ========================================================== */

  function finalizeProducts(
    productIds,
    bestCandidates
  ) {
    for (
      var i = 0;
      i < productIds.length;
      i++
    ) {
      var productId =
        String(productIds[i]);

      var hosts =
        getHosts(productId);


      if (hosts.length) {
        var current =
          getCurrentResult(
            hosts[0]
          );

        if (current) {
          setCardCache(
            productId,
            current
          );


          var currentId =
            getResultEntryId(
              current
            );


          var best =
            bestCandidates[
              productId
            ];


          if (
            best &&
            compareEntryIds(
              currentId,
              best.entryId
            ) === 0
          ) {
            setWinnerMeta(
              productId,
              best
            );

          } else {
            /*
             * Current result likely came from initial Liquid page 1.
             */
            setWinnerMeta(
              productId,
              {
                entryId:
                  currentId,

                page: 1,

                count:
                  parseInt(
                    current.getAttribute(
                      'data-sibling-count'
                    ) || '0',
                    10
                  ) || 0,

                handle:
                  current.getAttribute(
                    'data-sibling-entry-handle'
                  ) || ''
              }
            );
          }
        }
      }


      for (
        var h = 0;
        h < hosts.length;
        h++
      ) {
        hosts[h].setAttribute(
          VERIFIED_ATTRIBUTE,
          'true'
        );


        var placeholders =
          hosts[h].querySelectorAll(
            '[data-hfo-grid-sibling-placeholder]'
          );


        for (
          var p = 0;
          p < placeholders.length;
          p++
        ) {
          if (
            placeholders[p].parentNode
          ) {
            placeholders[p]
              .parentNode
              .removeChild(
                placeholders[p]
              );
          }
        }
      }
    }
  }



  /* ==========================================================
     RUN LOOKUP
     ========================================================== */

  function runLookup() {
    if (scanRunning) {
      scanAgain = true;
      return;
    }


    /*
     * First paint from localStorage immediately.
     */
    restoreAllLiveCaches();


    var pending =
      collectProducts();


    if (!pending.ids.length) {
      return;
    }


    scanRunning = true;


    var bestCandidates =
      Object.create(null);


    fetchResolverPage(
      1,
      pending.ids,
      pending.map,
      '',
      bestCandidates
    )

      .then(
        function (firstPage) {
          if (
            !firstPage ||
            !firstPage.valid
          ) {
            return [];
          }


          if (
            firstPage.totalPages <= 1
          ) {
            return [];
          }


          if (!firstPage.pageParam) {
            console.warn(
              'HFO siblings: paginate.page_param missing.'
            );

            return [];
          }


          /*
           * Pages 2..N fire together.
           */
          var requests = [];


          for (
            var page = 2;
            page <= firstPage.totalPages;
            page++
          ) {
            requests.push(
              fetchResolverPage(
                page,
                pending.ids,
                pending.map,
                firstPage.pageParam,
                bestCandidates
              )
            );
          }


          return Promise.all(
            requests
          );
        }
      )

      .then(
        function () {
          finalizeProducts(
            pending.ids,
            bestCandidates
          );
        }
      )

      .catch(
        function (error) {
          console.warn(
            'HFO sibling lookup failed:',
            error
          );
        }
      )

      .finally(
        function () {
          scanRunning = false;

          if (scanAgain) {
            scanAgain = false;

            setTimeout(
              runLookup,
              40
            );
          }
        }
      );
  }



  /* ==========================================================
     SCHEDULER
     ========================================================== */

  function scheduleLookup() {
    clearTimeout(scanTimer);

    scanTimer =
      setTimeout(
        runLookup,
        40
      );
  }


  window.HFORefreshGridSiblings =
    scheduleLookup;


  ensureSiblingScript();


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      runLookup,
      {
        once: true
      }
    );
  } else {
    runLookup();
  }



  /*
   * Fast retries for dynamically rendered theme grids/search.
   */

  setTimeout(
    runLookup,
    150
  );

  setTimeout(
    runLookup,
    500
  );



  /* ==========================================================
     DOM OBSERVER
     ========================================================== */

  var observer =
    new MutationObserver(
      function (mutations) {
        var shouldRun = false;


        for (
          var i = 0;
          i < mutations.length;
          i++
        ) {
          var nodes =
            mutations[i].addedNodes;


          for (
            var n = 0;
            n < nodes.length;
            n++
          ) {
            var node =
              nodes[n];


            if (
              !node ||
              node.nodeType !== 1
            ) {
              continue;
            }


            if (
              node.matches &&
              node.matches(
                '[data-hfo-grid-sibling-host][data-product-id]'
              )
            ) {
              shouldRun = true;
              break;
            }


            if (
              node.querySelector &&
              node.querySelector(
                '[data-hfo-grid-sibling-host][data-product-id]'
              )
            ) {
              shouldRun = true;
              break;
            }
          }


          if (shouldRun) {
            break;
          }
        }


        if (shouldRun) {
          /*
           * Cached swatches appear immediately.
           */
          restoreAllLiveCaches();

          scheduleLookup();
        }
      }
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );



  /* ==========================================================
     SEARCH TABS / FILTERS
     ========================================================== */

  document.addEventListener(
    'click',

    function (event) {
      var target = event.target;

      if (
        !target ||
        !target.closest
      ) {
        return;
      }

      if (
        target.closest(
          '[data-tabs-link]'
        )
      ) {
        setTimeout(
          scheduleLookup,
          150
        );
      }
    }
  );


  document.addEventListener(
    'change',

    function (event) {
      var target = event.target;

      if (
        !target ||
        !target.closest
      ) {
        return;
      }

      if (
        target.closest(
          '#SearchPage'
        )
      ) {
        setTimeout(
          scheduleLookup,
          200
        );
      }
    }
  );


  window.addEventListener(
    'pageshow',

    function () {
      restoreAllLiveCaches();

      setTimeout(
        scheduleLookup,
        20
      );
    }
  );

})();